/**
 * Auth guard
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { WdLocalEnvironmentService } from '../services/environment/wd-local-environment.service';

@Injectable()
export class AuthGuard {
  /**
   * Constructor
   */
  constructor(
    private wdLocalEnvironmentService: WdLocalEnvironmentService,
    private router: Router,
  ) {}

  /**
   * Has route permission check
   */
  static hasRoutePermission(url: string, permissions: any): boolean {
    if (url && permissions) {
      // Login
      if (url.includes('/login')) {
        return true;
      }
      // Forgotten Password
      if (url.includes('/password')) {
        return true;
      }
    }
    return false;
  }

  // noinspection JSUnusedGlobalSymbols
  /**
   * Can activate route check
   */
  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const url = state.url;
    const permissions = this.wdLocalEnvironmentService.values.permissions;

    if (!permissions) {
      void this.router.navigate(['errors', '403']);
      return false;
    }

    if (!AuthGuard.hasRoutePermission(url, permissions)) {
      void this.router.navigate(['errors', '403']);
    }

    return true;
  }
}
